import { render, staticRenderFns } from "./workDayFx2.vue?vue&type=template&id=4bf000fb&scoped=true"
import script from "./workDayFx2.vue?vue&type=script&lang=js"
export * from "./workDayFx2.vue?vue&type=script&lang=js"
import style0 from "./workDayFx2.vue?vue&type=style&index=0&id=4bf000fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf000fb",
  null
  
)

export default component.exports